export default __webpack_public_path__ + "static/media/SENAIT_NL_SEQ09.f6a28549.mp3";